import React from "react";
import "./SmallStatCard.css";
import User_icon from "assets/User_icon.svg";

interface SmallStatCardProps {
  icon: React.ReactNode;
  title: string;
  mainStat: {
    type: "Text" | "IconText";
    content: string | { iconUrl: string; text: string };
  };
  secondaryStat?: { type: "Percent" | "Hours"; value: number };
}

export const SmallStatCard: React.FC<SmallStatCardProps> = ({
  icon,
  title,
  mainStat,
  secondaryStat,
}) => {
  const renderMainStat = () => {
    if (title === "Best contributor") {
      return (
        <div className="main-stat-icon-text">
          <img src={User_icon} alt="User icon" className="main-stat-icon" />
          <span>{mainStat.content as string}</span>
        </div>
      );
    } else if (mainStat.type === "IconText") {
      const { iconUrl, text } = mainStat.content as { iconUrl: string; text: string };
      return (
        <div className="main-stat-icon-text">
          <img src={iconUrl} alt="Main stat icon" className="main-stat-icon" />
          <span>{text}</span>
        </div>
      );
    }

    return <div className="main-stat-text">{mainStat.content as string}</div>;
  };

  const renderSecondaryStat = () => {
    if (!secondaryStat) return null;

    if (secondaryStat.type === "Percent") {
      const color = secondaryStat.value > 0 ? "green" : "red";
      return (
        <div className="secondary-stat" style={{ color }}>
          {secondaryStat.value > 0 ? "↑" : "↓"} {secondaryStat.value}%
        </div>
      );
    }

    if (secondaryStat.type === "Hours") {
      return <div className="secondary-stat">{secondaryStat.value} hr</div>;
    }

    return null;
  };

  return (
    <div className="small-stat-card">
      <div className="small-stat-card-header">
        <img src={typeof icon === "string" ? icon : ""} alt="Icon" className="header-icon" />
        <div className="small-stat-card-title">{title}</div>
      </div>
      <div className="small-stat-card-counter-num">
        {renderMainStat()}
        <div className="small-stat-card-counter-status">
        {renderSecondaryStat()}
      </div>
      </div>
    </div>
  );
};

export default SmallStatCard;
